import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { storeManageListNewData} from './data'
import {setPageNewItem} from "@/utils";
import './index.scss'
import { getStorage,gotonext} from "@/utils";
import {
  refreshMenu,
} from "../../../../../../redux/common/action";
import {getInfo} from "../../../../../../servers/menuAPI";
import {savedata} from "../../../../../../servers/commonApi";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Button, message, Modal, Tooltip} from "antd";
import {dpeannexdefmap} from "../../../../../../utils/dpedatadef";
import { List, Card } from 'antd';
import { DownloadOutlined } from '@ant-design/icons'
import CButton from "../../../../../../components/CButton";
import CInput from "../../../../../../components/CForm/CInput";
import CSelect from "../../../../../../components/CForm/CSelect";
import CCheckbox from "../../../../../../components/CForm/CCheckbox";
import CSwitch from "../../../../../../components/CForm/CSwitch";
import CRadio from "../../../../../../components/CForm/CRadio";
import CDatePicker from "../../../../../../components/CForm/CDatePicker";
import CUpload from "../../../../../../components/CForm/CUpload";
import { Descriptions } from 'antd';

@CBaseComponent
class Infomations extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeEdit = this.onChangeEdit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }


  state = {
    data: storeManageListNewData,
    pglist:[
      {name:'有理事会（董事会）：理事会（董事会）由博物馆举办者或其代表、馆长、职工代表、社会人士组成。 / 2分',value:1},
      {name:'有其他形式决策机构 / 1分',value:2},
      {name:'无 / 0分',value:3},
    ],
    levelid:''
  }
  data = [
    'Racing car sprays burning fuel into crowd.',
    'Japanese princess to wed commoner.',
  ];

  onChangeEdit(data){
    const result = this.state.data
    const d = result[0].data
    d.forEach(item=>{
      if (item.id === data.id){
        item.ifEdit = !item.ifEdit
        if (data.hasupload!== '') {
          d.forEach(item1=>{
            if (item1.id === data.hasupload){
              item1.ifEdit = !item1.ifEdit
            }
          })
        }
      }
    })
    this.setState({
      data:result
    })
  }

  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      indid:'1.3.1'
    }
    // getInfo(params).then(res=>{
    //   const data = []
    //   res.records.forEach((item,index)=>{
    //     const obj = {}
    //     obj.id = item.code
    //     obj.name = item.name
    //     obj.placeholder=''
    //     obj.type= item.type === '1G10' ? 'input':'textarea'
    //     obj.checkType= item.minlimit > 0 ? 'required' : ''
    //     obj.newDisabled=false
    //     obj.editDisabled=false
    //     obj.newShow=true
    //     obj.editShow=true
    //     obj.ifEdit=item.type === '1G10' && item.annuname !=='' ? true : false
    //     obj.value= item.fillin ? decodeURIComponent(item.fillin): ''
    //     obj.options=[]
    //     obj.expand = {
    //       autosize: {minRows: 4, maxRows: 10}
    //     }
    //     obj.hasupload = ''
    //     obj.jpath = item.code
    //     obj.tips = item.formtips
    //     obj.showeditbtn = item.type === '1G10' && item.annuname!=='' ? true : false
    //     data.push(obj)
    //     if (item.annexdefids !== '' && item.annexdefids!==undefined) {
    //       const arr = item.annexdefids.split(',')
    //       arr.forEach(item1=>{
    //         const info = JSON.parse(JSON.stringify(dpeannexdefmap[item1]))
    //         const d = {
    //           id: info.id,
    //           name: '附件'+info.id+'.'+info.name,
    //           placeholder: '',
    //           type: 'img',
    //           checkType: '',
    //           newDisabled: false,
    //           editDisabled: false,
    //           newShow: true,
    //           editShow: true,
    //           value: item.annexlist,
    //           options: [],
    //           jpath:info.id,
    //           expand: {
    //             limit: 100
    //           },
    //           btnname: '附件',
    //         }
    //         data.push(d)
    //       })
    //     }
    //   })
    //   const obj = JSON.parse(JSON.stringify(this.state.data))
    //   obj[0].data = data
    //   this.setState({
    //     data:obj
    //   })
    // })
  }

  onSubmit(data){
    Modal.confirm({
      content: '确认提交数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.onSubmitHandler(data)
      }
    })
  }

  //下一步
  onCancel(data){
    Modal.confirm({
      content: '确认提交数据到下一个填报页面?',
      okText: '确认',
      cancelText: '取消',
      onOk:()=>{
        this.onSubmitHandler(data,'tz')
      }
    })
  }

  onSubmitHandler(data, type=''){
    if (data.status){
      for (let key in data.data) {
        if (typeof data.data[key] !== 'string' && typeof data.data[key] !== 'number'){
          delete data.data[key]
        }
      }
      const params = JSON.parse(JSON.stringify(data.data))
      params.annual = localStorage.getItem('year')
      savedata(params).then(res=>{
        if(res.statecode === 0) {
          this.props.refreshMenu(true)
          message.success('保存成功');
           if (type === 'tz'){
            gotonext()
            this.props.history.push({
              pathname: '/informationDeclaration/standardManage/open/visit',
            });
          }
        } else {
          message.error(res.statemessage);
        }
      })
    }
  }

  componentDidMount(){
    // this.onSelect()
  }

  render(){
    return (
      <div className='store-manage-list-new' id='top'>
        <List
            header={
              <div className='flex c-page-new-item-title'>
                <span className='title-before-icon'></span>
                1 综合管理与基础设施 / 1.1 法人治理结构 / 1.1.1 决策机构(9分)
              </div>
        }
            footer={<div className='c-page-footer-button'>
              <CButton size='larger' type='primary' className="confirm" onClick={this.submitHandler}>保存</CButton>
              <CButton size='larger' onClick={this.cancelHandler}>下一步</CButton>
            </div>}
            dataSource={this.data}
            renderItem={(item) => (
                <List.Item>
                  <div className='form-block'>
                    <div className="form-title">
                      <div className='form-title-left'>决策机构形式(2分)</div>
                      <div className='form-title-right'>
                        <span>评分：</span><CInput style={{width:'60px',margin:'5px 5px 5px 0'}}/><span>分</span>
                      </div>
                    </div>
                    <div className="form-form">
                        <div style={{display:'flex',flexDirection:'column'}}>
                          <CRadio value={this.state.levelid}
                                  options={this.state.pglist}
                          />
                        </div>
                      <div>
                        <Card size="small" title="附件002：博物馆法人登记证书或主管部门批准博物馆成立的其他文件" extra={
                          <CButton type="primary">
                            上传文件
                          </CButton>
                        } style={{ width: '100%',marginTop:"20px" }}>
                          <Descriptions column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }} bordered >
                            <Descriptions.Item label="文件名称">博物馆法人登记证书或主管部门批准博物馆成立的其他文件</Descriptions.Item>
                            <Descriptions.Item label="操作">
                              <Button type="link">预览</Button>
                              <Button type="link" style={{marginLeft:'-20px'}}>下载</Button>
                              <Button type="link" style={{color:'red',marginLeft:'-20px'}}>
                                删除
                              </Button>
                            </Descriptions.Item>
                          </Descriptions>
                          <Descriptions column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }} bordered  style={{marginTop:'20px'}}>
                            <Descriptions.Item label="文件名称">博物馆法人登记证书或主管部门批准博物馆成立的其他文件</Descriptions.Item>
                            <Descriptions.Item label="操作">
                              <Button type="link">预览</Button>
                              <Button type="link" style={{marginLeft:'-20px'}}>下载</Button>
                            </Descriptions.Item>
                          </Descriptions>
                        </Card>
                        <Card size="small" title="附件002：博物馆法人登记证书或主管部门批准博物馆成立的其他文件" extra={
                          <CButton type="primary">
                            上传文件
                          </CButton>
                        } style={{ width: '100%',marginTop:"20px" }}>
                          <Descriptions column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }} bordered >
                            <Descriptions.Item label="文件名称">博物馆法人登记证书或主管部门批准博物馆成立的其他文件</Descriptions.Item>
                            <Descriptions.Item label="操作">
                              <Button type="link">预览</Button>
                              <Button type="link" style={{marginLeft:'-20px'}}>下载</Button>
                              <Button type="link" style={{color:'red',marginLeft:'-20px'}}>
                                删除
                              </Button>
                            </Descriptions.Item>
                          </Descriptions>
                          <Descriptions column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }} bordered  style={{marginTop:'20px'}}>
                            <Descriptions.Item label="文件名称">博物馆法人登记证书或主管部门批准博物馆成立的其他文件</Descriptions.Item>
                            <Descriptions.Item label="操作">
                              <Button type="link">预览</Button>
                              <Button type="link" style={{marginLeft:'-20px'}}>下载</Button>
                            </Descriptions.Item>
                          </Descriptions>
                        </Card>
                      </div>
                    </div>
                  </div>
                </List.Item>
            )}
        />
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.year,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Infomations);

